import{defaultMsg as t}from"../internal/default-msg.js";let m=t;export{m as msg};
